import request from "../request";

export const getDate = () => request.get('date').then((res) => res);